import { createStore } from "redux";
import rootReducer from "./rootReducer";

// add middleware
const store = createStore(rootReducer);

export default store;
